<template>
  <div>
  <div class="page-title">
      <div class="container">
        <h1><strong> Paiement rapide </strong></h1>
        <ul class="breadcrumbs">
          <li><router-link to="/">Home</router-link>
          </li>
          <li class="separator">&nbsp;/&nbsp;</li>
          <li><strong> Paiement rapide </strong></li>
        </ul>
      </div>
  </div>
    <!-- Page Content-->
    <div class="container padding-bottom-3x mb-2">
      <div class="row">
        <!-- Checkout Address-->
        <div class="col-xl-9 col-lg-8">
          <h4><strong> Remplissez les champs suivants pour confirmer votre commande </strong>
</h4>
  <h4><strong> املأ المعلومات التالية لتأكيد طلبك
    </strong>
</h4>
          <hr class="padding-bottom-1x">

          <form>
          <div v-if="!isAuthenticated" class="row">
             <div class="col-sm-6">
              <div class="form-group">
                <label for="firstName"><strong>Prénom   :* الاسم الأول</strong></label>
                <input name="firstName" class="form-control" type="text" v-model="user.firstName" >
                <span class="alert-box alert-danger">{{ errors.first('firstName') }}</span>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="lastName"><strong>Nom de famille :* اسم العائلة
</strong></label>
                <input name="lastName" class="form-control" type="text" v-model="user.lastName">
                <span class="alert-box alert-danger">{{ errors.first('lastName') }}</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div v-if="!isAuthenticated" class="col-sm-6">
              <div class="form-group">
                <label for="email"><strong>E-mail: البريد الإلكتروني
 </strong></label>
                <input  class="form-control" name="email" type="email" v-model="user.email">
                <span class="alert-box alert-danger">{{errors.first('email')}}</span>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="address"><strong>Adresse personnelle  :* العنوان الشخصي</strong></label>
                <input name="address" class="form-control" type="text" v-model="user.address">
                <span class="alert-box alert-danger">{{ errors.first('address') }}</span>
              </div>
            </div>
             <div v-if="!isAuthenticated" class="col-sm-6">
              <div class="form-group">
                <label for="phoneNumber"><strong>Téléphone de client: * رقم الهاتف</strong></label>
                <input  class="form-control" name="phoneNumber" type="phoneNumber" disabled  v-model="user.phoneNumber">
                <span class="alert-box alert-danger">{{errors.first('phoneNumber')}}</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label for="checkout-city"><strong>Wilaya de livraison ولاية التسليم</strong></label>
               <select id="delivery_id_state"  v-model="deliveryWilaya" name="delivery_id_state" class="delivery required form-control input-sm not_unifrom not_uniform " data-field-name="id_state" data-default-value="" data-required="1"> <option value="">--</option><option data-text="01 - Adrar" data-iso-code="DZ01" value="Adrar">01 - Adrar</option><option data-text="02 - Chlef" data-iso-code="DZ02" value="Chlef">02 - Chlef</option><option data-text="03 - Laghouat" data-iso-code="DZ03" value="Laghouat">03 - Laghouat</option><option data-text="04 - Oum El Bouaghi" data-iso-code="DZ04" value="Oum El Bouaghi">04 - Oum El Bouaghi</option><option data-text="05 - Batna" data-iso-code="DZ05" value="Batna">05 - Batna</option><option data-text="06 - Béjaïa" data-iso-code="DZ06" value="Béjaïa">06 - Béjaïa</option><option data-text="07 - Biskra" data-iso-code="Biskra" value="Biskra">07 - Biskra</option><option data-text="08 - Béchar" data-iso-code="DZ08" value="Béchar">08 - Béchar</option><option data-text="09 - Blida" data-iso-code="DZ09" value="Blida">09 - Blida</option><option data-text="10 - Bouira" data-iso-code="DZ10" value="Bouira">10 - Bouira</option><option data-text="11 - Tamanrasset" data-iso-code="DZ11" value="Tamanrasset">11 - Tamanrasset</option><option data-text="12 - Tébessa" data-iso-code="DZ12" value="349">12 - Tébessa</option><option data-text="13 - Tlemcen" data-iso-code="DZ13" value="Tlemcen">13 - Tlemcen</option><option data-text="14 - Tiaret" data-iso-code="DZ14" value="Tiaret">14 - Tiaret</option><option data-text="15 - Tizi Ouzou" data-iso-code="DZ15" value="Tizi Ouzou">15 - Tizi Ouzou</option><option data-text="16 - Alger" data-iso-code="DZ16" value="Alger">16 - Alger</option><option data-text="17 - Djelfa" data-iso-code="DZ17" value="Djelfa">17 - Djelfa</option><option data-text="18 - Jijel" data-iso-code="DZ18" value="355">18 - Jijel</option><option data-text="19 - Sétif" data-iso-code="DZ19" value="Sétif">19 - Sétif</option><option data-text="20 - Saïda" data-iso-code="DZ20" value="Saïda">20 - Saïda</option><option data-text="21 - Skikda" data-iso-code="DZ21" value="Skikda">21 - Skikda</option><option data-text="22 - Sidi Bel Abbès" data-iso-code="DZ22" value="Sidi Bel Abbès">22 - Sidi Bel Abbès</option><option data-text="23 - Annaba" data-iso-code="DZ23" value="Annaba">23 - Annaba</option><option data-text="24 - Guelma" data-iso-code="DZ24" value="Guelma">24 - Guelma</option><option data-text="25 - Constantine" data-iso-code="DZ25" value="Constantine">25 - Constantine</option><option data-text="26 - Médéa" data-iso-code="Médéa" value="363">26 - Médéa</option><option data-text="27 - Mostaganem" data-iso-code="DZ27" value="364">27 - Mostaganem</option><option data-text="28 - M&amp;#039;Sila" data-iso-code="DZ28" value="M'Sila">28 - M'Sila</option><option data-text="29 - Mascara" data-iso-code="DZ29" value="Mascara">29 - Mascara</option><option data-text="30 - Ouargla" data-iso-code="DZ30" value="Ouargla">30 - Ouargla</option><option data-text="31 - Oran" data-iso-code="DZ31" value="Oran">31 - Oran</option><option data-text="32 - El Bayadh" data-iso-code="DZ32" value="El Bayadh">32 - El Bayadh</option><option data-text="33 - Illizi" data-iso-code="DZ33" value="Illizi">33 - Illizi</option><option data-text="34 - Bordj Bou Arreridj" data-iso-code="DZ34" value="Bordj Bou Arreridj">34 - Bordj Bou Arreridj</option><option data-text="35 - Boumerdès" data-iso-code="DZ35" value="Boumerdès">35 - Boumerdès</option><option data-text="36 - El Tarf" data-iso-code="DZ36" value="El Tarf">36 - El Tarf</option><option data-text="37 - Tindouf" data-iso-code="DZ37" value="Tindouf">37 - Tindouf</option><option data-text="38 - Tissemsilt" data-iso-code="DZ38" value="Tissemsilt">38 - Tissemsilt</option><option data-text="39 - El Oued" data-iso-code="DZ39" value="El Oued">39 - El Oued</option><option data-text="40 - Khenchela" data-iso-code="DZ40" value="Khenchela">40 - Khenchela</option><option data-text="41 - Souk Ahras" data-iso-code="DZ41" value="Souk Ahras">41 - Souk Ahras</option><option data-text="42 - Tipaza" data-iso-code="DZ42" value="Tipaza">42 - Tipaza</option><option data-text="43 - Mila" data-iso-code="DZ43" value="Mila">43 - Mila</option><option data-text="44 - Aïn Defla" data-iso-code="DZ44" value="Aïn Defla">44 - Aïn Defla</option><option data-text="45 - Naâma" data-iso-code="DZ45" value="Naâma">45 - Naâma</option><option data-text="46 - Aïn Témouchent" data-iso-code="DZ46" value="Aïn Témouchent">46 - Aïn Témouchent</option><option data-text="47 - Ghardaïa" data-iso-code="DZ47" value="Ghardaïa">47 - Ghardaïa</option><option data-text="48 - Relizane" data-iso-code="DZ48" value="Relizane">48 - Relizane</option></select>
            <div class="col-sm-6">
              </div>

            </div>


<div class="form-group">
                <label for="deliveryAddress"><strong>Adresse de la livraison  :* عنوان التسليم</strong></label>
                <input  name="deliveryAddress" class="form-control" type="text" v-model="user.deliveryAddress">
                <span class="alert-box alert-danger">{{ errors.first('deliveryAddress') }}</span>
              </div>
               </div>
          </div>
<div class="accordion" id="accordion1" role="tablist">
              <div class="card">
                <div class="card-header" role="tab">
                  <h6><a class="collapsed" href="#collapseTwo" data-toggle="collapse" data-parent="#accordion1"><strong>à livrer pour : للتوصيل إلى</strong></a></h6>
                </div>
                <div class="collapse" id="collapseTwo" role="tabpanel">
                  <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label for="deliveryfn"><strong>Prénom de réceptionneur de colis: الاسم الأول لمستقبِل الطرود</strong></label>
                <input  class="form-control" type="text" name="deliveryfn" v-model="deliveryFirstName">
                <span class="alert-box alert-danger">{{errors.first('deliveryfn')}}</span>
              </div>
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="deliveryln"><strong>Nom de famille de réceptionneur de colis : اسم العائلة لمستقبِل الطرود</strong></label>
                <input  class="form-control" type="text" name="deliveryln" v-model="deliveryLastName">
                <span class="alert-box alert-danger">{{errors.first('deliveryln')}}</span>
              </div>
            </div>
          </div>
          <div class="row">
           <div class="form-group">
                <label for="deliveryph"><strong>Téléphone de réceptionneur de colis: هاتف استقبال الطرود</strong></label>
                <input class="form-control" type="text" name="deliveryph" v-model="deliveryPhoneNumber">
                <span class="alert-box alert-danger">{{errors.first('deliveryph')}}</span>
              </div>

          </div>
                </div>
              </div>
            </div>

          </form>
<br>
<br>

          <hr class="padding-bottom-1x">
          <div class="d-flex justify-content-between">
          <router-link class="btn btn-outline-secondary m-0" to="/cart"><strong> Retour </strong></router-link>
          <router-link class="btn btn-primary m-0" to="/review" :disabled="!isComplete"><strong> Valider </strong></router-link></div>
        </div>

        <!-- Sidebar          -->
        <div class="col-xl-3 col-lg-4">
          <aside class="sidebar">
            <div class="padding-top-2x hidden-lg-up"></div>
            <!-- Order Summary Widget-->
            <section class="widget widget-order-summary bg-secondary border-0 p-4">
              <h3 class="widget-title"><strong> Récapitulatif de la commande </strong></h3>
              <table class="table text-sm mb-0">
                <tr>
                  <td><strong> Total: </strong></td>
                  <td class="text-medium"><strong> {{total}} DA </strong></td>
                </tr>
                <tr>
                  <td><strong> frais de livraison: </strong></td>
                  <td class="text-medium"><strong> 0.00 DA </strong></td>
                </tr>
                <tr>
                  <td></td>
                  <td class="text-lg text-medium"><strong> {{total}} DA </strong></td>
                </tr>
              </table>
            </section>
            <!-- Featured Products Widget-->

            <!-- Promo Banner-->
            <!--<div class="fw-section mt-1 px-4 py-5 text-center" style="background-image: url(static/img/banners/alert-bg.jpg);">
              <h3 class="text-white">Check our <br><span class='text-bold'>Latest Offers.</span><br> Save up to <span class='text-bold'>50%</span></h3><a class="btn btn-primary btn-sm" href="#">View Offers</a>
            </div>
            -->
          </aside>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { mapGetters } from 'vuex';
export default {
  computed: {
    isComplete (){
      return this.firstName && this.address  && this.lastName && this.deliveryAddress && this.phoneNumber && this.deliveryWilaya
    },
    total() {
      return this.products.reduce((total, p) => {
        return total + p.price * p.quantity;
      }, 0);
    },
    ...mapGetters({ products: 'cartProducts', isAuthenticated: 'isAuthenticated' , user:'user' }),
    ...mapFields([
      'user.firstName',
      'user.lastName',
      'user.address',
      'user.phoneNumber',
      'user.email',
      'user.deliveryAddress',
      'user.billingAdress',
      'user.deliveryPostalCode',
      'user.deliveryFirstName',
      'user.deliveryLastName',
      'user.deliveryPhoneNumber',
      'user.deliveryWilaya',
      'user.wilaya'
    ])
  }
};
</script>


<style scoped>
/*.form-group label {
  text-transform: none;
}*/
.page-title {
  margin-top: 1.5em;
}
</style>






// WEBPACK FOOTER //
// src/components/checkout/payment.vue